import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _typeof from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import createComponent from './index.js';
export default {
  lazy: false,
  model: {
    prop: 'model',
    event: 'input'
  },
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    schema: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isSearchForm: {
      type: Boolean,
      default: true
    },
    isExpand: {
      type: Boolean,
      default: false
    },
    expandNumber: {
      type: Number,
      default: 3
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    size: {
      type: String,
      default: 'mini'
    },
    inline: {
      type: Boolean,
      default: true
    },
    // 是否加：
    labelPrefix: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: '92px'
    },
    componentWidth: {
      type: String,
      default: 'auto'
    },
    css: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formName: {
      type: String,
      default: 'form-creater-schema'
    }
  },
  data: function data() {
    return {
      filtersTags: ['submit-buttons', 'block'],
      clearValidateField: new Set(),
      checkAll: [],
      updating: false,
      expandAll: false,
      formValues: {}
    };
  },
  computed: {
    isCanExpand: function isCanExpand() {
      return this.expandNumber > 0 && Object.keys(this.schema).length > this.expandNumber;
    }
  },
  watch: {
    formValues: {
      handler: function handler(values) {
        var _this = this;

        this.updating = true; // 解决clear的默认赋值: null 的情况，如果有默认值设置为defaultValue，没有则设置空字符串

        Object.keys(values).map(function (field) {
          if (_this.schema[field]) {
            if (Object.prototype.hasOwnProperty.call(_this.schema[field], 'defaultValue') && values[field] === null) {
              values[field] = _this.schema[field]['defaultValue'];
            }
          }
        });
        this.$emit('input', values);
      },
      deep: true
    },
    schema: {
      handler: function handler() {
        if (!this.updating) {
          this.formValues = this.mergeValues();
        } else {
          this.updating = false;
        }
      },
      deep: true
    }
  },
  updated: function updated() {
    var _this2 = this;

    // 设置inline为true时，给(el-radio 和 el-checkbox)加上特殊的样式
    this.$nextTick(function () {
      // 设置el-form-item下样式
      Array.from(document.querySelectorAll(".".concat(_this2.formName, " .el-form-item-special .el-form-item__content"))).forEach(function (element) {
        element.style = 'display:block;margin-left:0px;';
      });
      Array.from(document.querySelectorAll(".".concat(_this2.formName, " .el-form-item .el-form-item__content"))).forEach(function (element) {
        element.style = "width:calc(100% - ".concat(_this2.labelWidth, " )");
      }); // 设置el-form-item的label，使其统一

      Array.from(document.querySelectorAll(".".concat(_this2.formName, " .el-form-item-special .el-form-item__label"))).forEach(function (element) {
        element.style = "min-width: ".concat(_this2.labelWidth);
      }); // 设置el-form-item_search_buttons的按钮样式，使其对象

      if (document.querySelector(".".concat(_this2.formName, " .el-form-item_search_buttons .el-form-item__content"))) {
        document.querySelector(".".concat(_this2.formName, "  .el-form-item_search_buttons .el-form-item__content")).style = 'line-height:32px';
      }
    });
  },
  methods: {
    // 合并values，并设置默认值
    mergeValues: function mergeValues() {
      var _this3 = this;

      var vm = this;
      var model = vm.model;
      var defaultValues = {};
      Object.keys(this.schema).map(function (key) {
        var item = _this3.schema[key];
        var _item$defaultValue = item.defaultValue,
            defaultValue = _item$defaultValue === void 0 ? null : _item$defaultValue,
            tag = item.tag,
            _item$attrs = item.attrs,
            attrs = _item$attrs === void 0 ? {} : _item$attrs;

        if (!_this3.filtersTags.includes(tag)) {
          if (tag === 'el-checkbox' || tag === 'el-select' && attrs.multiple) {
            defaultValue = defaultValue != null ? defaultValue : [];
          }

          defaultValues[key] = defaultValue || '';
        }
      });
      return _objectSpread(_objectSpread({}, defaultValues), model);
    },
    // 根据tag去创建组件
    getTagForCreateComponent: function getTagForCreateComponent(tag, h, value, vm, item) {
      var component = []; // 根据tag类型，判断创建组件的方式：特殊组件 和 普通组件

      tag = createComponent[tag] ? tag : 'component'; // console.info(tag);
      // 创建组件

      component = createComponent[tag](h, value, vm, item); //

      return component;
    },
    // 创建查询按钮
    renderSearchButtons: function renderSearchButtons(h) {
      var _this4 = this;

      var vm = this;
      return [h('el-form-item', {
        class: {
          'el-form-item_search_buttons': true
        },
        style: {
          float: 'right'
        },
        props: {
          label: ''
        }
      }, [h('el-button', {
        props: {
          size: vm.size,
          type: 'primary'
        },
        style: {
          width: '88px',
          marginRight: '16px'
        },
        on: {
          click: function click() {
            vm.$emit('submit', vm.formValues);
          }
        }
      }, '查询'), h('el-button', {
        props: {
          size: vm.size
        },
        style: {
          width: '88px',
          marginLeft: 0,
          marginRight: '16px'
        },
        on: {
          click: function click() {
            // 设置默认值
            Object.keys(vm.formValues).map(function (field) {
              var item = _this4.schema[field];

              if (item) {
                var _item$defaultValue2 = item.defaultValue,
                    defaultValue = _item$defaultValue2 === void 0 ? null : _item$defaultValue2;

                if (defaultValue) {
                  // 判断组件，是否有设置默认值：defaultValue
                  vm.formValues[field] = defaultValue;
                } else {
                  // 设置值类型，默认值
                  vm.formValues[field] = vm.resetDefaultByValue(vm.formValues[field]);
                }
              }
            });
            vm.$emit('reset');
          }
        }
      }, '重置'), vm.isCanExpand ? h('el-button', {
        style: {
          display: !vm.expandAll ? '' : 'none',
          color: '#4379F0'
        },
        props: {
          size: vm.size,
          type: 'text'
        },
        on: {
          click: function click() {
            vm.expandAll = !vm.expandAll;
          }
        }
      }, ['展开', h('i', {
        class: {
          'el-icon-arrow-down': true
        },
        style: {
          display: 'inline-block',
          marginLeft: '4px'
        }
      })]) : h('span'), h('el-button', {
        style: {
          display: vm.expandAll ? '' : 'none',
          color: '#4379F0'
        },
        props: {
          size: vm.size,
          type: 'text'
        },
        on: {
          click: function click() {
            vm.expandAll = !vm.expandAll;
          }
        }
      }, ['收起', h('i', {
        class: {
          'el-icon-arrow-up': true
        },
        style: {
          display: 'inline-block',
          marginLeft: '4px'
        }
      })])])];
    },
    resetDefaultByValue: function resetDefaultByValue(val) {
      if (Array.isArray(val)) {
        return [];
      } else if (_typeof(val) === 'object' && val) {
        return {};
      } else {
        return '';
      }
    },
    renderComponent: function renderComponent(h, item, key) {
      var isRenderFormItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return this.renderFormItem(h, item, key, isRenderFormItem);
    },
    renderFormItem: function renderFormItem(h, item, key) {
      var _this5 = this;

      var isRenderFormItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var _item$label = item.label,
          label = _item$label === void 0 ? '' : _item$label,
          _item$rules = item.rules,
          rules = _item$rules === void 0 ? null : _item$rules,
          _item$name = item.name,
          name = _item$name === void 0 ? key : _item$name,
          tag = item.tag,
          _item$on = item.on,
          on = _item$on === void 0 ? {} : _item$on,
          _item$vif = item.vif,
          vif = _item$vif === void 0 ? {} : _item$vif,
          _item$itemStyle = item.itemStyle,
          itemStyle = _item$itemStyle === void 0 ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '20px'
      } : _item$itemStyle,
          _item$expand = item.expand,
          expand = _item$expand === void 0 ? true : _item$expand,
          _item$inline = item.inline,
          inline = _item$inline === void 0 ? true : _item$inline,
          _item$line = item.line,
          line = _item$line === void 0 ? false : _item$line,
          _item$loading = item.loading,
          loading = _item$loading === void 0 ? false : _item$loading; // 默认加上loading样式/颜色/文字

      item.attrs = Object.assign(item.attrs || {}, {
        'element-loading-text': item.loadingText || '',
        'element-loading-background': item.loadingBackground || '',
        'disabled': loading
      }); //

      var vm = this; //

      var formValues = vm.formValues,
          size = vm.size; // 获取value

      var value = formValues[name]; // 合并事件

      Object.assign(on, {
        input: function input(value) {
          formValues[name] = value;
        }
      });
      item.on = on; // message 默认

      rules = !rules || Array.isArray(rules) ? rules : Object.assign({
        message: '必填'
      }, rules); // 获取组件

      var renderComponent = this.getTagForCreateComponent(tag, h, value, vm, item); // if 逻辑

      var ifConditionBool = true;

      if (typeof vif === 'boolean' || vif === undefined) {
        // bool值vif
        ifConditionBool = vif;
      } else if (Array.isArray(vif)) {
        // 非空值vif: ['city','area']
        vif.map(function (key) {
          if (!_this5.formValues[key] && ifConditionBool) {
            ifConditionBool = false;
          }
        });
      } else if (_typeof(vif) === 'object') {
        // 简单值vif: {city:1}
        Object.keys(vif).map(function (key) {
          if (_this5.formValues[key] !== vif[key] && ifConditionBool) {
            ifConditionBool = false;
          }
        });
      } else if (typeof vif === 'string') {
        // 复杂vif: "$model.city===1 || $model.select===2"
        vif = vif.replace(/(\$model)/g, 'this.model'); // eslint-disable-next-line no-eval

        ifConditionBool = eval(vif);
      } // 条件隐藏的字段，需要移除验证


      if (!ifConditionBool) {
        // 标记移除验证
        vm.clearValidateField.add(name);
      } else {
        vm.clearValidateField.delete(name);
      }

      if (!isRenderFormItem) return renderComponent;
      var elItem = h('el-form-item', {
        ref: name,
        class: {
          // 设置inline为true时，给(el-radio 和 el-checkbox)加上特殊的样式
          'el-form-item-special': vm.inline !== inline && (tag !== 'submit-buttons' || tag !== 'text' || vm.isSearchForm) && label && tag !== 'submit-buttons'
        },
        style: _objectSpread({
          display: ifConditionBool && (expand || this.expandAll) ? (tag !== 'submit-buttons' || label) && vm.inline !== inline || (_typeof(tag) === 'object' || tag === 'submit-buttons') && !inline ? 'flex' : '' : 'none',
          // block 组件定制样式
          borderBottom: tag === 'block' && line ? '1px solid #ececec' : '',
          paddingBottom: tag === 'block' && line && value ? '10px' : '',
          width: tag === 'block' ? '100%' : '100%'
        }, !vm.isSearchForm && inline && tag === 'submit-buttons' ? itemStyle : {}),
        attrs: {
          key: name
        },
        props: {
          size: size,
          prop: name,
          label: label.length === 0 || /(\s)$/.test(label) ? label : vm.labelPrefix && !/(:|：)$/.test(label) && label ? label + vm.labelPrefix : label,
          rules: rules,
          labelWidth: item.labelWidth || vm.labelWidth
        }
      }, renderComponent);

      if (vm.inline) {
        return h('el-col', {
          attrs: _objectSpread({
            span: 6
          }, item.attrs)
        }, [elItem]);
      } else {
        return h('el-col', {
          attrs: _objectSpread({}, item.attrs),
          style: {
            clear: item.colClear ? item.colClear : 'none'
          }
        }, [elItem]);
      }
    },
    // 渲染 el-form-item 里的组件
    renderFormItems: function renderFormItems(h) {
      var _this6 = this;

      return Object.keys(this.schema).map(function (key, index) {
        // key当作name来处理
        _this6.schema[key].name = key; // 是否展开/收起

        if (_this6.isExpand) _this6.schema[key].expand = _this6.expandNumber > 0 ? index < _this6.expandNumber : true; //

        if (_this6.schema[key].tag === 'slot') {
          // 渲染占位slot
          return _this6.$slots[_this6.schema[key].slot];
        } else {
          // 渲染formItem
          return _this6.renderFormItem(h, _this6.schema[key], key);
        }
      });
    },
    // 重置表单项的验证
    resetFields: function resetFields(fields) {
      var _this7 = this;

      if (Array.isArray(fields)) {
        fields.map(function (field) {
          _this7.$nextTick(function () {
            _this7.$refs[field].resetField();
          });
        });
      } else if (this.$refs[fields]) {
        this.$nextTick(function () {
          _this7.$refs[fields].resetField();
        });
      }
    },
    // 提交表单
    submitForm: function submitForm() {
      var vm = this;
      var fieldList = Array.from(vm.clearValidateField);
      var validBool = true; // console.log(this.model);
      // 移除验证

      fieldList.forEach(function (field) {
        if (Object.prototype.hasOwnProperty.call(vm.$refs[field], 'resetField')) {
          vm.$refs[field].resetField();
        }
      }); // 验证字段

      vm.$refs[vm.formName].validate(function (valid, model) {
        Object.keys(model).forEach(function (field) {
          if (!fieldList.includes(field)) {
            validBool = false;
          } else if (fieldList.length > 0 && fieldList.includes(field)) {
            vm.$refs[field].resetField();
          }
        });
      });
      return validBool;
    },
    // 重置表单
    resetForm: function resetForm() {
      var vm = this; // 清楚隐藏字段的数据

      vm.clearValidateField.clear(); // 重置表单

      vm.$refs[vm.formName].resetFields();
    }
  },
  render: function render(h) {
    var vm = this;
    return h('el-row', {
      attrs: {
        gutter: 20
      },
      style: _objectSpread({}, Object.keys(vm.css).length > 0 || !vm.inline ? vm.css : {}),
      class: _defineProperty({}, vm.formName, vm.formName)
    }, [h('el-form', {
      ref: vm.formName,
      class: {
        'form-creater-container': true
      },
      attrs: {
        disabled: vm.disabled || false
      },
      props: {
        model: vm.formValues,
        inline: vm.inline,
        labelWidth: vm.labelWidth,
        labelPosition: vm.labelPosition
      }
    }, [].concat(_toConsumableArray(vm.$slots.prepend || []), _toConsumableArray(vm.renderFormItems(h) || []), _toConsumableArray(vm.inline && vm.isSearchForm ? vm.renderSearchButtons(h) : []), _toConsumableArray(vm.$slots.append || [])))]);
  }
};